// extracted by mini-css-extract-plugin
export default {"container":"TextInput_container__zc9Tj","label":"TextInput_label__gGIX8","input":"TextInput_input__SmGOi"};